import nyNetwork from "@/api/nyBaseNetwork";
import DZSearchAgentUser from "@/views/代理商管理/model/DZSearchAgentUser";
import DZModelProcess from "@/views/代理商管理/model/DZModelProcess";

class DZServiceAgentUser{

    m_search = new DZSearchAgentUser(10);

    list_agent : Array<DZModelAgentUser> = []

    m_process = new DZModelProcess();

    net_user_list(){
        nyNetwork.net("代理商用户列表",this.m_search, res => {
            this.list_agent = res.list
            this.m_search.total = res.total
        })
    }

    net_operate_user(success: () => void){
        nyNetwork.net('审核代理商',this.m_process,res =>{
            success()
        })
    }


}
export default DZServiceAgentUser